import { IActivityHistoryItem, TSearchActivityHistoryItemPredicate } from "../model";
import { Spec } from "./spec";
import { propContainsString } from "../../../utils/prop-contains-string";

const commonFieldsSearchPredicate = (item: IActivityHistoryItem, searchString: string) => {
  const professionalNameContainsSearchString =
    item.professional?.name && propContainsString(item.professional?.name, searchString);
  const centerNameContainsSearchString = item.center?.description && propContainsString(item.center.description, searchString);
  const specialityNameContainsSearchString =
    item.professional?.speciality?.description && propContainsString(item.professional?.speciality.description, searchString);
  const roleNameContainsSearchString =
    item.professional?.role?.description && propContainsString(item.professional?.role.description, searchString);
  const serviceNameContainsSearchString = item.service?.description && propContainsString(item.service.description, searchString);
  const upNameContainsSearchString = item.up?.description && propContainsString(item.up.description, searchString);
  const diagnosticsMatch = item.diagnostics?.some(
    (diagnostic) => propContainsString(diagnostic.descripcio, searchString),
  );
  return (
    professionalNameContainsSearchString ||
    centerNameContainsSearchString ||
    specialityNameContainsSearchString ||
    roleNameContainsSearchString ||
    serviceNameContainsSearchString ||
    upNameContainsSearchString ||
    diagnosticsMatch
  );
};

export class SearchStringSpec extends Spec<IActivityHistoryItem> {
  constructor(
    public searchString: string,
    public searchPredicate: TSearchActivityHistoryItemPredicate,
  ) {
    super();
  }

  isSatisfiedBy(context: IActivityHistoryItem): boolean {
    // Si searchString está vacío o solo tiene espacios, no filtramos y devolvemos true
    if (!this.searchString?.trim()) {
      return true;
    }

    // Verificamos coincidencias en los campos comunes
    const matchesCommonFields = commonFieldsSearchPredicate(context, this.searchString);

    // Verificamos coincidencias con el searchPredicate
    let matchesSearchPredicate = false;
    if (this.searchPredicate) {
      try {
        matchesSearchPredicate = !!this.searchPredicate(this.searchString.toLowerCase(), context);
      } catch {
        // searchPredicate de plugin externo lanzó un error — se trata como no-match
      }
    }

    // Aseguramos que siempre se retorne un valor booleano
    return !!(matchesCommonFields || matchesSearchPredicate);
  }
}
